"use client";
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { cardHover } from '../anim/variants';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glassmorphism?: boolean;
}

export function Card({ 
  children, 
  className = "", 
  hover = true,
  glassmorphism = false
}: CardProps) {
  const baseClasses = glassmorphism
    ? "bg-white/70 backdrop-blur-md border border-white/60"
    : "bg-white";
    
  const hoverClasses = hover
    ? "transition-all duration-200 hover:-translate-y-0.5 hover:shadow-2xl focus-visible:ring-2 focus-visible:ring-blue-500"
    : "";

  return (
    <motion.div
      className={`rounded-2xl shadow-lg ${baseClasses} ${hoverClasses} ${className}`}
      variants={hover ? cardHover : undefined}
      whileHover={hover ? "hover" : undefined}
    >
      {children}
    </motion.div>
  );
}
